import { render, staticRenderFns } from "./AddProjects.vue?vue&type=template&id=1e33c676&"
import script from "./AddProjects.vue?vue&type=script&lang=js&"
export * from "./AddProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports